import React from 'react';
import MainLayout from 'components/layout/Main/desktop/MainLayout';
import LayoutPartner from 'components/layout/Partner';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import { AppRoutes, RoutesV1 } from 'constants/appRoutes';
import useDevice from 'hooks/useDevice';
import { useLocation } from 'react-router-dom';

const EmptyLayout = ({ children }) => children;

const Layouts = {
	main: MainLayout,
	partner: LayoutPartner,
	empty: EmptyLayout,
};

const Layout = ({ children, ...props }) => {
	const loadingInfoProfile = useSelector((state) => state.userProfile.loading);
	const { isMobile } = useDevice();
	const location = useLocation();
	const getLayout = () => {
		switch (location.pathname) {
			case '/pages/loyalty-store':
			case '/pages/loyalty-voucher':
			case '/pages/loyalty-store/detail':
				return 'main';
			default:
				return 'empty';
		}
	};

	const Container = Layouts[getLayout()];

	return (
		<Spin spinning={loadingInfoProfile}>
			<Container {...props} isMobile={isMobile}>
				{children}
			</Container>
		</Spin>
	);
};

export default Layout;
